import React from 'react';
import LeadershipComponent from '../components/Leadership/Leadership';

/**
 * LeadershipPage - Leadership page wrapper
 */
export default function LeadershipPage() {
  return <LeadershipComponent />;
}
